<!--
 * @Description: file content
 * @Author: yangsibo
 * @Date: 2022-05-12 10:24:14
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-07-11 16:29:59
 * @FilePath: \YunYin_admin\src\views\Setting\RoleManagement\components\RemoveRole.vue
-->
<template>
  <!-- 移除角色弹窗 -->
  <el-dialog
    class="dialog-bg dialog-remove-role"
    :title="operation == 1 ? '移除角色' : '删除角色'"
    :visible.sync="dialogRemoveRoleVisible"
    :before-close="close"
    width="480px"
  >
    <div class="tip"><i class="el-icon-warning"></i>请谨慎操作</div>
    <div class="con" v-if="operation == 1">
      是否确认将账号：
      <span>{{
        curAccountDetail.loginName + " " + curAccountDetail.fullName
      }}</span
      >从{{ curRoleDetail.roleName }}的角色中移除？
    </div>
    <div v-else class="con">
      是否确认删除角色：<span>{{ curRoleDetail.roleName }}</span>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancelRemoveRole">取消</el-button>
      <el-button type="primary" @click="handleSureRemoveRole">{{
        operation == 1 ? "移除" : "删除"
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "RemoveRole",
  data() {
    return {};
  },
  props: {
    dialogRemoveRoleVisible: {
      type: Boolean,
      default: () => true,
    },
    curAccountDetail: {
      type: Object,
      default: () => {},
    },
    curRoleDetail: {
      type: Object,
      default: () => {},
    },
    operation: {
      type: Number,
      default: () => 1,
    },
    systemType: {
      type: Number,
      default: 2,
    },
  },
  components: {},
  computed: {},
  methods: {
    /**
     * @description:
     * @Author: yangsibo
     * @Date: 2022-05-24 09:39:38
     * @return {*}
     */
    close(type) {
      this.$emit("close", "dialogRemoveRoleVisible", type);
    },
    /**
     * @descripttion: 取消移除角色
     * @Author: juanjuanhui
     * @Date: 2022-02-19 16:36:36
     */
    handleCancelRemoveRole() {
      this.close(
        this.operation == 1
          ? "dialogMemberVisible"
          : "dialogConfigRoleAuthVisible"
      );
    },
    /**
     * @descripttion: 取消移除角色
     * @Author: juanjuanhui
     * @Date: 2022-02-19 16:36:36
     */
    handleSureRemoveRole() {
      if (this.operation == 1) {
        this.delRefAccountRole();
      } else {
        this.delRole();
      }
    },
    /**
     * @description: 移除角色
     * @Author: yangsibo
     * @Date: 2022-05-25 15:19:25
     * @return {*}
     */
    async delRefAccountRole() {
      let params = {
        accountId: this.curAccountDetail.id,
        roleId: this.curRoleDetail.id,
      };
      try {
        let { status } = await this.$http.role.delRefAccountRole({
          ...params,
          systemType: this.systemType,
        });
        if (status == 1) {
          this.$message({
            type: "success",
            message: "移除角色成功",
            duration: 2000,
          });
          this.close();
          this.$emit("getRoleList");
        }
      } catch (error) {}
    },
    /**
     * @description: 删除角色
     * @Author: yangsibo
     * @Date: 2022-05-25 15:18:50
     * @return {*}
     */
    async delRole() {
      try {
        let { status } = await this.$http.role.delRole({
          id: this.curRoleDetail.id,
          systemType: this.systemType,
        });
        if (status == 1) {
          this.$message({
            type: "success",
            message: "删除角色成功",
            duration: 2000,
          });
          this.close();
          this.$emit("getRoleList");
        }
      } catch (error) {}
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.dialog-remove-role {
  ::v-deep .el-dialog__header {
    padding: 0;
    text-align: center;
    .el-dialog__title {
      font-size: 22px;
      color: #242424;
      font-weight: 400;
    }
  }
  ::v-deep .el-dialog__body {
    padding: 20px 0;
    .tip {
      display: flex;
      align-items: center;
      height: 35px;
      padding: 0 23px;
      color: #ff8400;
      background-color: #fff7ef;
      .el-icon-warning {
        margin-right: 5px;
      }
    }
    .con {
      padding: 20px 50px;
      font-size: 20px;
      color: #444444;
      span {
        color: #018388;
      }
    }
  }
}
</style>
